import styled, { css } from 'styled-components'

export const FilterDisplayContainer = styled.div`
  padding: ${({ theme }) => theme.spacing.medium};
  background: ${({ theme }) => theme.colors.background.secondary};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  border: 1px solid ${({ theme }) => theme.colors.border.light};
`

export const FilterDisplayContent = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.medium};
  flex-wrap: wrap;
`

export const FilterGroupContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.small};
  flex-wrap: wrap;
`

export const FilterGroupLabel = styled.span`
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  font-size: ${({ theme }) => theme.typography.fontSize.small};
  color: ${({ theme }) => theme.colors.text.secondary};
  margin-right: ${({ theme }) => theme.spacing.small};
`

interface FilterChipContainerProps {
  $size?: 'small' | 'medium'
  $active?: boolean
  $clickable?: boolean
}

export const FilterChipContainer = styled.div<FilterChipContainerProps>`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  border-radius: 16px;
  line-height: 1.3;
  font-weight: 500;
  transition: all 0.2s ease;
  white-space: nowrap;
  user-select: none;

  ${({ $size }) =>
    $size === 'small'
      ? css`
          padding: 4px 10px;
          font-size: 11px;
        `
      : css`
          padding: 5px 11px;
          font-size: 11px;
        `}

  ${({ $active, theme }) =>
    $active
      ? css`
          background: ${theme.colors.primary}20;
          color: ${theme.colors.primary};
          border: 1px solid ${theme.colors.primary};
        `
      : css`
          background: ${theme.colors.background.secondary};
          color: ${theme.colors.text.primary};
          border: 1px solid ${theme.colors.border.light};
        `}

  ${({ $clickable, $active, theme }) =>
    $clickable &&
    css`
      cursor: pointer;

      &:hover {
        background: ${$active
          ? theme.colors.primary + '30'
          : theme.colors.background.tertiary};
        border-color: ${$active
          ? theme.colors.primary
          : theme.colors.border.default};
        transform: translateY(-1px);
        box-shadow: ${theme.shadows.sm};
      }

      &:active {
        transform: translateY(0);
      }
    `}

  svg {
    width: 11px;
    height: 11px;
  }
`

export const FilterDivider = styled.div`
  width: 1px;
  height: 24px;
  background: ${({ theme }) => theme.colors.border.light};
  margin: 0 ${({ theme }) => theme.spacing.small};
  flex-shrink: 0;
`
